import { AmplitudeExperiments, AmplitudeVariants } from '../AmplitudeExperiments';
import { useAmplitudeExperimentBase } from '../utils/useAmplitudeExperimentBase';

export const useLearningToRankSearchReRanking = () =>
    useAmplitudeExperimentBase(
        AmplitudeExperiments.LearningToRankSearchReRanking,
        AmplitudeVariants.LearningToRankSearchReRanking.Control
    );
